import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret_down_outlined",
  "use": "icon-caret_down_outlined-usage",
  "viewBox": "0 0 8 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 6\" id=\"icon-caret_down_outlined\">\r\n  <defs>\r\n    <style>\r\n      #icon-caret_down_outlined .cls-1 {\r\n        fill: #666;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-caret_down_outlined_多边形_5\" data-name=\"多边形 5\" class=\"cls-1\" d=\"M4,0,8,6H0Z\" transform=\"translate(8 6) rotate(180)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol